import GetSuppliersLookupRequestModelBase from '../_generated/modelBases/get-suppliers-lookup-request-model-base';

export default class GetSuppliersLookupRequestModel extends GetSuppliersLookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
